import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import BalanceSheetReportLines from 'models/BalanceSheetReportLinesModel';

import {
  BalanceSheetClassificationTypeLabels,
  BalanceSheetAccountTypeLabels,
} from 'enums/balance-sheet-account-types';

const BalanceSheetRecord = Record({
  id: 0,
  currency: null,
  charts: [],
  createDate: new Date(0),
  lastBankTransactionDate: null,
});

export default class BalanceSheet extends BalanceSheetRecord {
  static deserialize(jsonObject) {
    if (
      typeof jsonObject === 'undefined' ||
      jsonObject === null ||
      Object.keys(jsonObject).length === 0
    ) {
      return undefined;
    }

    const mapProperties = {
      createDate: Hydrator.timestamp2Date,
      charts: BalanceSheetReportLines.deserialize,
      lastBankTransactionDate: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new BalanceSheet(hydrated);
  }

  getAccountType(accountType) {
    const items = this.charts.map((chart) => chart.charts);
    const flattened = [].concat(...items);
    return flattened.find((i) => BalanceSheetAccountTypeLabels[accountType] === i.accountType);
  }

  getClassification(classification) {
    return this.charts.find(
      (chart) => chart.classification === BalanceSheetClassificationTypeLabels[classification],
    );
  }
}
